"use client";
import { useEffect } from "react";
import { agbalumo } from "~/app/fonts";
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // clear local storage : state of the like menu might be different
    if (typeof window !== "undefined") {
      window.localStorage.clear();
    }
    // Log the error
    console.error(error);
  }, [error]);
  return (
    <html>
      <body>
        <nav
          id="fun-navbar"
          className="sticky top-0 z-[100] flex h-14 w-full items-center justify-between lg:h-20"
        >
          <div className="h-14 w-28 lg:h-20 lg:w-52"></div>

          <a
            href="/"
            aria-label="homepage link"
            className={`${agbalumo.className} fun-logo -mt-[.4rem] inline-block text-[1.75rem] tracking-wider text-white lg:p-3 lg:text-[2.5rem]`}
          >
            FundayList
          </a>
          <div className="relative flex h-14 w-28 justify-end lg:h-20 lg:w-52"></div>
        </nav>
        <div className="fun-body relative flex min-h-screen flex-col items-center justify-center leading-none">
          <div className="absolute top-[4rem] p-5 text-center lg:top-[6rem]">
            <h2 className="mb-2 text-[1.2rem] leading-6 text-brown lg:text-[1.5rem] lg:leading-7">
              Sorry, something went wrong with FundayList.
              <br /> We are currently trying to resolve the issue.
            </h2>
            <div className="mt-2 flex flex-col items-center justify-center">
              <p className="p-4">Try clicking below to reset the app.</p>
              <button
                className="w-full max-w-[12rem] rounded-md bg-orange p-4 font-[500] uppercase text-white"
                onClick={() => {
                  reset();
                }}
              >
                Reset App
              </button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
